import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jobdetails',
  templateUrl: './jobdetails.component.html',
  styleUrls: ['./jobdetails.component.css']
})
export class JobdetailsComponent implements OnInit {
  copyButton: boolean = true;
  copiedButton: boolean = false;
  
  constructor() { }

  ngOnInit(): void {
  }

  jsonData = `
  curl 'https://api.optimusdrive.ai/vod/v1/video/job'
  -H 'authorization: idtokenxxx’ 
  `


  sucessData=`
  {
    "data": {
      "Jobs": [
        {
          "id": "{{id}}",
          "created_at": "{{created_at}}",
          "updated_at": "{{updated_at}}",
          "downloading_time": "{{downloading_time}}",
          "processing_time": "{{processing_time}}",
          "transcoding_time": "{{transcoding_time}}",
          "input_info": {
            "resolution": "{{resolution}}",
            "class_label": "{{class_label}}",
            "frame_rate": "{{frame_rate}}",
            "bit_rate": "{{bit_rate}}",
            "file_size": "{{file_size}}",
            "filename": "{{filename}}",
            "duration": "{{duration}}",
            "height": "{{height}}",
            "width": "{{width}}"
          },
          "output_info": {
            "variants": [
              {
                "name": "{{name}}",
                "output_url": "{{output_url}}",
                "thumbnail_url": "{{thumbnail_url}}",
                "resolution": "{{resolution}}",
                "class_label": "{{class_label}}",
                "frame_rate": "{{frame_rate}}",
                "bit_rate": "{{bit_rate}}",
                "file_size": "{{file_size}}",
                "height": "{{height}}",
                "width": "{{width}}"
              }
            ],
            "hls_manifest": "{{hls_manifest}}"
          },
          "source": "{{source}}",
          "source_path": "{{source_path}}",
          "crunch_mode": "{{crunch_mode}}",
          "status": "{{status}}",
          "output_video_codec": "{{output_video_codec}}",
          "abr_type": "{{abr_type}}",
          "status_history": [
            {
              "status": "{{status}}",
              "event_time": "{{event_time}}"
            }
          ]
        }
      ]
    }
  }  
  `


  Error5x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `

  Error401x=`
  {
    "error": "ValidationException: The provided starting key is outside query boundaries based on provided conditions\n\tstatus code: 400, request id: 4NLO7LL1PEKKHB21C8F0PDNHSJVV4KQNSO5AEMVJF66Q9ASUAAJG",
    "message": "Error while fetching the job details"
  }
  
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.jsonData);
  }



}
